import React from 'react'
import { Button } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import routes from '../../../helpers/routes'
import ConfirmedOrders from './ConfirmedOrders'
import ForConfirmOrders from './ForConfirmOrders/index'
import { CurrentOrdersContainer, MainSection, TopSection } from '../styles'
import { SellOrderContext } from '../../../providers/SellOrdersProvider'
import useMediaQuery from '../../../hooks/useMediaQuery'
import MobileHeader from '../../../components/MobileHeader'
import SegmentedControl from '../../../components/SegmentedControl'

function CurrentSellOrders() {
  const { isLoading, isError, porConfirmar } = React.useContext(SellOrderContext);
  const history = useHistory();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [tab, setTab] = React.useState<'confirmadas' | 'por-confirmar'>(() => 'confirmadas');

  if (isLoading) return <CurrentOrdersContainer>Cargando...</CurrentOrdersContainer>

  if (isError) return <CurrentOrdersContainer>Hubo un error en la carga de datos</CurrentOrdersContainer>

  return (
    <CurrentOrdersContainer>
      <TopSection>
        <Button variant="success" onClick={() => history.push(routes.ventas.nueva)}>Nueva venta</Button>
      </TopSection>
      {isMobile && (
        <MobileHeader
          left={<Button size="sm" variant="success" onClick={() => history.push(routes.ventas.nueva)}>Nueva venta</Button>}
          right={<SegmentedControl
            items={[
              { key: 'confirmadas', label: 'Confirmadas' },
              { key: 'por-confirmar', label: 'Por confirmar', count: porConfirmar?.length ?? 0 },
            ]}
            activeKey={tab}
            onChange={(k) => setTab(k as 'confirmadas' | 'por-confirmar')}
          />}
        />
      )}
      <MainSection>
        {isMobile ? (
          tab === 'confirmadas' ? <ConfirmedOrders /> : <ForConfirmOrders />
        ) : (
          <>
            <ForConfirmOrders />
            <ConfirmedOrders />
          </>
        )}
      </MainSection>
    </CurrentOrdersContainer>
  )
}

export default CurrentSellOrders